import { useState } from 'react';

interface PopupProps {
  url: string; // Define the 'url' prop as a string
  hyperlink: string;
}

function Popup({ url, hyperlink }: PopupProps) {
  const [isOpen, setIsOpen] = useState(false);

  const openPopup = () => {
    setIsOpen(true);
  };

  const closePopup = () => {
    setIsOpen(false);
  };

  return (
    <div className="relative">
      <button onClick={openPopup} className="text-blue-600 underline">
        {hyperlink}
      </button>
      {isOpen && (
        <div className="fixed inset-32 left-0  flex items-center ">
          <div className="bg-white p-4 rounded-lg ">
            <button onClick={closePopup} className="flex items-end mt-2 mr-2 text-gray-600 hover:text-gray-50">
              Close
            </button>
            <iframe
              src={url} // Use the 'url' prop here
              title="Popup"
              height="1000"
              className="w-[70vw] h-[90vh]"
            ></iframe>
          </div>
        </div>
      )}
    </div>
  );
}

export default Popup;
